import React, { useState } from 'react';
import './DeckManager.css';

export const DeckManager = ({
  allDecks,
  customDecks,
  onAddDeck,
  onDeleteDeck,
  onRenameDeck,
  onSelectDeck,
  onClose
}) => {
  const [isAddingDeck, setIsAddingDeck] = useState(false);
  const [newDeckName, setNewDeckName] = useState('');
  const [editingDeck, setEditingDeck] = useState(null);
  const [editDeckName, setEditDeckName] = useState('');
  const [error, setError] = useState('');

  const handleAddDeck = () => {
    if (!newDeckName.trim()) {
      setError('Deck name cannot be empty');
      return;
    }
    if (allDecks[newDeckName]) {
      setError('Deck name already exists');
      return;
    }
    const success = onAddDeck(newDeckName.trim());
    if (success) {
      setNewDeckName('');
      setIsAddingDeck(false);
      setError('');
    } else {
      setError('Failed to create deck');
    }
  };

  const handleStartRename = (deckName) => {
    setEditingDeck(deckName);
    setEditDeckName(deckName);
    setError('');
  };

  const handleRename = () => {
    if (!editDeckName.trim()) {
      setError('Deck name cannot be empty');
      return;
    }
    if (editDeckName !== editingDeck && allDecks[editDeckName]) {
      setError('Deck name already exists');
      return;
    }
    const success = onRenameDeck(editingDeck, editDeckName.trim());
    if (success) {
      setEditingDeck(null);
      setEditDeckName('');
      setError('');
    } else {
      setError('Failed to rename deck');
    }
  };

  const handleDelete = (deckName) => {
    if (window.confirm(`Are you sure you want to delete "${deckName}"? All cards will be lost.`)) {
      onDeleteDeck(deckName);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="deck-manager" onClick={(e) => e.stopPropagation()}>
        <div className="deck-manager-header">
          <h2>Manage Decks</h2>
          <button className="close-btn" onClick={onClose}>✕</button>
        </div>

        {error && <div className="error-message">{error}</div>}

        <div className="deck-manager-content">
          <div className="deck-section">
            <h3>Default Decks</h3>
            <div className="deck-list">
              {Object.keys(allDecks).filter(name => !customDecks[name]).map((deckName) => (
                <div key={deckName} className="deck-item default">
                  <div className="deck-info">
                    <span className="deck-name">{deckName}</span>
                    <span className="deck-count">{allDecks[deckName].length} cards</span>
                  </div>
                  <button
                    className="btn-study"
                    onClick={() => {
                      onSelectDeck(deckName);
                      onClose();
                    }}
                  >
                    Study
                  </button>
                </div>
              ))}
            </div>
          </div>

          <div className="deck-section">
            <div className="section-header">
              <h3>Custom Decks</h3>
              {!isAddingDeck && (
                <button
                  className="btn-add-deck"
                  onClick={() => setIsAddingDeck(true)}
                >
                  + New Deck
                </button>
              )}
            </div>

            {isAddingDeck && (
              <div className="add-deck-form">
                <input
                  type="text"
                  placeholder="Enter deck name..."
                  value={newDeckName}
                  onChange={(e) => setNewDeckName(e.target.value)}
                  onKeyPress={(e) => e.key === 'Enter' && handleAddDeck()}
                  autoFocus
                />
                <div className="form-actions">
                  <button className="btn-save" onClick={handleAddDeck}>Create</button>
                  <button
                    className="btn-cancel"
                    onClick={() => {
                      setIsAddingDeck(false);
                      setNewDeckName('');
                      setError('');
                    }}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            )}

            <div className="deck-list">
              {Object.keys(customDecks).length === 0 && !isAddingDeck ? (
                <div className="empty-state-small">
                  No custom decks yet. Create one to get started!
                </div>
              ) : (
                Object.keys(customDecks).map((deckName) => (
                  <div key={deckName} className="deck-item custom">
                    {editingDeck === deckName ? (
                      <div className="edit-deck-form">
                        <input
                          type="text"
                          value={editDeckName}
                          onChange={(e) => setEditDeckName(e.target.value)}
                          onKeyPress={(e) => e.key === 'Enter' && handleRename()}
                          autoFocus
                        />
                        <div className="form-actions">
                          <button className="btn-save" onClick={handleRename}>Save</button>
                          <button
                            className="btn-cancel"
                            onClick={() => {
                              setEditingDeck(null);
                              setEditDeckName('');
                              setError('');
                            }}
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    ) : (
                      <>
                        <div className="deck-info">
                          <span className="deck-name">{deckName}</span>
                          <span className="deck-count">{customDecks[deckName].length} cards</span>
                        </div>
                        <div className="deck-actions">
                          <button
                            className="btn-study"
                            onClick={() => {
                              onSelectDeck(deckName);
                              onClose();
                            }}
                          >
                            Study
                          </button>
                          <button
                            className="btn-rename"
                            onClick={() => handleStartRename(deckName)}
                            title="Rename deck"
                          >
                            ✏️
                          </button>
                          <button
                            className="btn-delete"
                            onClick={() => handleDelete(deckName)}
                            title="Delete deck"
                          >
                            🗑️
                          </button>
                        </div>
                      </>
                    )}
                  </div>
                ))
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
